import { useEffect } from "react";
import PASentry from "util/pa-sentry";

function useSafeEffect(func: any, deps: any[]) {
  useEffect(() => {
    try {
      return func();
    } catch (err) {
      PASentry.logException(err);
    }
    return () => {};
  }, deps);
}

export default useSafeEffect;
